<template>
    <!--    overflow-hidden-->
    <div class="bg-white shadow rounded-lg flex flex-col justify-between">
        <!--                    header-->
        <div class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
            <div class="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
                <div class="ml-4 mt-4">
                    <h3 class="text-lg leading-6 font-medium text-gray-500">
                        <slot name="title">
                            <template v-if="titleUrl === null">
                                {{ title }}
                            </template>
                            <template v-else>
                                <a :href="titleUrl" class="text-indigo-500">
                                    {{ title }}
                                </a>
                            </template>
                        </slot>
                    </h3>
                </div>
            </div>
        </div>

        <!--                    body-->
        <div class="bg-white px-4 py-5 sm:px-6" style="position: relative">
            <slot />
        </div>

        <!--                    footer-->
        <div class="bg-gray-50 px-5 py-3">
            <div class="text-sm leading-5">
                <slot name="footer">
                    <template v-if="footerUrl === null">
                        {{ footer }}
                    </template>
                    <template v-else>
                        <a :href="footerUrl" class="text-indigo-500">
                            {{ footer }}
                        </a>
                    </template>
                </slot>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'BaseWidget',
    props: {
        // widget: {
        //     type: String,
        //     default: null,
        // },
        title: {
            type: String,
            default: null,
        },
        titleUrl: {
            type: String,
            default: null,
        },
        footer: {
            type: String,
            default: null,
        },
        footerUrl: {
            type: String,
            default: null,
        },
    },
};
</script>
